<script setup lang="ts">
import { NTabPane, NTabs } from 'naive-ui'
import { onMounted } from 'vue'

import useThemeVars from '@lib/composables/useThemeVars'
import { useI18n } from 'vue-i18n'
import useApiStore from '@browser/stores/api'
import useAppStore from '@browser/stores/app'
import QuickAccessPanelItem from '@browser/components/Content/Panel/QuickAccessPanelItem.vue'
import { useLocalStorage } from '@vueuse/core'

const { t } = useI18n()
const themeVars = useThemeVars()
const { state: apiState } = useApiStore()
const { sortedFavorites, filteredRecentFiles, enabledFavorites, enabledRecents } = useAppStore()
const activeQuickAccessSection = useLocalStorage<'recent' | 'favorites'>('activeQuickAccessSection', 'recent')

onMounted(() => {
  apiState.recentFilesFetcher?.()
})
</script>
<template>
  <NTabs
    class="panel flex animated pa-4 rounded-2 flex-col h-full items-center"
    :default-value="activeQuickAccessSection"
    justify-content="space-evenly"
    pane-class="flex flex-col w-full flex-1 px-4 overflow-auto"
    panel
    py-4
    rounded-2
    :style="{ '--n-tab-border-color': themeVars.primary5 }"
    tab-class="mt-[-2px]"
    type="line"
    @update:value="activeQuickAccessSection = $event"
  >
    <NTabPane v-if="enabledRecents" name="recent" :tab="t('canvasUI.browserApp.content.recent')">
      <template v-if="filteredRecentFiles.length">
        <QuickAccessPanelItem
          v-for="(item, index) in filteredRecentFiles"
          :key="item.id"
          :is-even="Number(index) % 2 === 0"
          :item="item"
        />
      </template>
      <div v-else class="flex justify-center pt-8">{{ t('canvasUI.browserApp.content.recentEmpty') }}</div>
    </NTabPane>
    <NTabPane v-if="enabledFavorites" name="favorites" :tab="t('canvasUI.browserApp.content.favorites')">
      <template v-if="sortedFavorites.length">
        <QuickAccessPanelItem
          v-for="(item, index) in sortedFavorites"
          :key="item.id"
          :is-even="Number(index) % 2 === 0"
          is-favorite
          :item="item"
        />
      </template>
      <div v-else class="flex justify-center pt-8">{{ t('canvasUI.browserApp.content.favoritesEmpty') }}</div>
    </NTabPane>
  </NTabs>
</template>

<style scoped>
.panel {
  background-color: v-bind('themeVars.base');
}
</style>
